// Angular
import { AfterViewInit, Component, OnInit, Injector } from '@angular/core';
// Layout
import { LayoutConfigService } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { AppComponentBase } from '@shared/app-component-base';
import { AppConsts } from '@shared/AppConsts';

@Component({
	selector: 'kt-brand',
	templateUrl: './brand.component.html',
	styleUrls: ['brand.component.scss']
})
export class BrandComponent extends AppComponentBase implements OnInit, AfterViewInit {
	// Public properties
	headerLogo: string;
	headerStickyLogo: string;
	menuHeaderDisplay: boolean;

	defaultUrl: string;
	constructor(
		injector: Injector,
		private layoutConfigService: LayoutConfigService,
		public htmlClassService: HtmlClassService) {

		super(injector);
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.defaultUrl = this.appSession.user.userDefaultPageUrl;

		this.headerLogo = this.layoutConfigService.getLogo();
		this.headerStickyLogo = this.layoutConfigService.getStickyLogo();

		const config = this.layoutConfigService.getConfig();


		//UserCustomerTheme varsa, portal logosu theme uzerinden okunur.
		var userCustomerPortalLogoPath = this.appSession.user.appCustomerThemeInfo.portalLogoPath;
		
		if (userCustomerPortalLogoPath != ""){
			this.headerLogo = AppConsts.userCustomerTheme.path + "/" + userCustomerPortalLogoPath ;

		}
		

		// get menu header display option
		// this.menuHeaderDisplay = objectPath.get(config, 'header.menu.self.display');
	}

	/**
	 * On after view init
	 */
	ngAfterViewInit(): void {
	}
}
